import { useState } from "react";
import { useParams } from "react-router-dom"; 
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2";
import Navbar from "../../component/Navbar";
import { useNavigate } from "react-router-dom";


function UpdateAgentPassword() {
  const { userid } = useParams(); // Get the userid from the URL
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // inside your component

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
  
    if (!password || !confirmPassword) {
      Swal.fire("Missing Fields", "Please fill in both password fields.", "error");
      return;
    }
  
    if (password !== confirmPassword) {
      Swal.fire("Mismatch", "Passwords do not match.", "error");
      return;
    }
  
    setLoading(true);
  
    const requestData = { password };
  
    console.log("Updating password for agent ID:", userid);
  
    try {
      const response = await axios.put(`${baseurl}updateAgentPasswordByID/${userid}`, requestData);
  
      Swal.fire("Success", response.data.message || "Password updated successfully!", "success").then(() => {
        navigate("/login"); // redirect after user clicks OK
      });
  
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Password update error:", error.response?.data || error.message);
      Swal.fire("Error", error.response?.data?.message || "Failed to update password.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Navbar/>
      <div className="bgagent">
        <div className="container-fluid pt-5">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card p-4 shadow-sm">
                <h3 className="text-center mb-4">🔐 Update Password</h3>
                <form onSubmit={handlePasswordUpdate}>
                  <div className="mb-3 text-start">
                    <label htmlFor="password" className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="Enter new password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3 text-start">
                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? "Updating..." : "Update Password"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateAgentPassword;
